<template>
  <v-main class="green lighten-4">
    <v-container fluid fill-height>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="6" lg="4" xl="3">
          <div align="center">
            <v-dialog v-model="dialog" :max-width="videoWidth">
              <template v-slot:activator="{ on, attrs }">
                <v-avatar v-bind="attrs" v-on="on" size="150" color="info darken-2"><span
                    class="text-h4 white--text font-weight-bold">人脸<br>识别</span></v-avatar>
              </template>
              <v-card>
                <v-card-title class="headline grey lighten-2">人像识别<v-spacer></v-spacer><span>{{facetxt}}</span></v-card-title>
                <div ref="facebox" style="position: relative;">
                  <video id="facevideo" ref="video" :width="faceWidth" :height="faceHeight" autoplay></video>
                  <canvas ref="canvas" width="faceWidth" :height="faceHeight" style="position: absolute;left: 0;top: 0;"></canvas>
                </div>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialog = false">帐号登录</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card class="ml-5 elevation-2" max-width="150" style="display: inline-flex;vertical-align: middle;border-radius: 20px;">
              <v-img src="../../assets/mpqr.jpg"></v-img>
            </v-card>
            <h1 class="my-4 green--text text--darken-3 text-h5 text-sm-h4 font-weight-bold">{{$store.state.guser}}</h1>
            <v-btn class="my-4 green--text text--darken-3 text-h6 text-sm-h6 font-weight-bold" large text @click="$router.push('map');">农业投入品一张图</v-btn>
          </div>
          <v-card class="elevation-12">
            <v-toolbar color="green darken-2" dark flat>
              <v-toolbar-title>承诺达标合格证管理平台登录</v-toolbar-title>
              <v-spacer></v-spacer>
              <a v-show="this.$vuetify.breakpoint.width > 500" href="./download/print.zip" style="color: white;">驱动下载</a>
            </v-toolbar>
            <v-card-text>
              <v-form ref="loginForm">
                <v-text-field label="账号" prepend-icon="mdi-account" type="text" clearable v-model="username"
                  :rules="[rules.required, ...rules.username]" validate-on-blur></v-text-field>
                <v-text-field label="密码" @keyup.enter="tologin(false)" prepend-icon="mdi-lock"
                  :type="showpassword?'text':'password'" :append-icon="showpassword?'mdi-eye-off':'mdi-eye'"
                  @click:append="showpassword = !showpassword" clearable v-model="password"
                  :rules="[rules.required, ...rules.password]" validate-on-blur>
                </v-text-field>
                <v-text-field v-if="CaptchaIds != ''" label="验证码" prepend-icon="mdi-puzzle" type="text" clearable
                  v-model="Captcha" :rules="[rules.required, rules.captcha]" validate-on-blur>
                  <template v-slot:append-outer>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-img v-bind="attrs" v-on="on" @click="tologin(true)" contain :src="CaptchaB64s" width="90">
                        </v-img>
                      </template>
                      <span>点击刷新验证码</span>
                    </v-tooltip>
                    <v-btn small class="ml-2 white--text" color="info" router to="/pwd">忘记密码</v-btn>
                  </template>
                </v-text-field>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn class="white--text" color="orange" router to="/reg">注册</v-btn>
              <v-spacer></v-spacer>
              <v-btn class="white--text" :loading="loading" color="green" @click="tologin(false)">登录</v-btn>
            </v-card-actions>
          </v-card>
          <div style="height: 120px;"></div>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
  import axios from 'axios'
  require('@/plugins/tracking/tracking-min.js')
  require('@/plugins/tracking/data/face.js')
  export default {
    data: function () {
      return {
        faceloginnum: 0,
        loginingnums: 0,
        faceWidth: 640,
        faceHeight: 480,
        videoWidth: 640,
        videoHeight: 480,
        oldrect: {x:0,y:0,width:0,height:0},
        timerreadcard: null,
        facetxt: '正在启动摄像头...',
        tracker: null,
        dialog: false,
        username: "",
        password: "",
        Captcha: "",
        showpassword: false,
        loading: false,
        CaptchaIds: "",
        CaptchaB64s: "",
        rules: {
          required: (value) => !!value || "必填项",
          username: [
            (value) =>
              value === null ||
              (value.length >= 2 && value.length <= 20) ||
              "长度为2-20",
            (value) =>
              value === null ||
              /^[\u4e00-\u9fa5_a-zA-Z0-9][\u4e00-\u9fa5_a-zA-Z0-9\@\.]+$/.test(
                value
              ) ||
              "字符范围(汉字、_、a-z、A-Z、0-9)",
          ],
          password: [
            (value) =>
              value === null ||
              (value.length >= 6 && value.length <= 20) ||
              "长度为6-20",
          ],
          captcha: (value) =>
            value === null ||
            /^[a-z0-9][a-z0-9]{3}$/.test(value) ||
            "长度为4,字符范围(a-z,0-9)",
        },
      }
    },
    created() {
      this.$store.commit("settoken", null);
      this.$store.commit("setuserInfo", null);

      sessionStorage.clear()
      let _this = this
      this.timerreadcard = setInterval(() => {
        _this.readcard()
      }, 1000);
    },
    beforeDestroy() {
      clearInterval(this.timerreadcard);
    },
    watch: {
      dialog(val) {
        this.faceloginnum = 0
        this.loginingnums = 0
        if (val) {
          // H5调用电脑摄像头API
          navigator.mediaDevices.getUserMedia({ video: true }).then(success => {
            // 摄像头开启成功
            this.$refs['video'].srcObject = success
            // 实时拍照效果
            this.$refs['video'].play()
            
            setTimeout(() => {
              this.initvideo()
            }, 500);
          }).catch(error => {
            console.error('摄像头开启失败，请检查摄像头是否可用！', error)
            this.$store.commit("setsnack", { message: "摄像头开启失败，请检查摄像头是否可用！" });
          })
        } else {
          this.tracker && this.tracker.removeListener('track', this.handleTracked) && tracking.track('#facevideo', this.tracker, { camera: false });
          let canvas = this.$refs['canvas']
          canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
          this.faceWidth = 640
          this.faceHeight = 480
          if (!this.$refs['video'].srcObject) { return }
          let stream = this.$refs['video'].srcObject
          let tracks = stream.getTracks()
          tracks.forEach(track => { track.stop() })
          this.$refs['video'].srcObject = null
        }
      },
    },
    methods: {
      initvideo(num=0){
        if (this.$refs.video.videoWidth > 0){
          this.videoWidth = this.$refs.video.videoWidth
          this.videoHeight = this.$refs.video.videoHeight
          this.faceWidth = this.$refs.facebox.offsetWidth
          this.faceHeight = parseInt(this.faceWidth*(this.videoHeight/this.videoWidth))

          this.facetxt = ""
          setTimeout(() => {
            this.tracker = new tracking.ObjectTracker('face');
            this.tracker.setInitialScale(4);
            this.tracker.setStepSize(2);
            this.tracker.setEdgesDensity(0.1);
            tracking.track('#facevideo', this.tracker);
            this.startvideo()
          }, 1000);
        }else{
          console.log('摄像头初始化失败：', num);
          num++
          if(num < 10){
            setTimeout(() => {
              this.initvideo(num)
            }, 500);
          }
        }
      },
      readcard(){
        if (this.loading){return}
        axios.get('http://127.0.0.1:19196/opendevice').then(res=>{
          //这里并不会成功，为什么呢？？先不管了！
          if(res.resultFlag == 0){
            this.readcard2()
          }
        }).catch(res=>{
          if(res.resultFlag == 0){
            //这里是成功的结果
            this.readcard2()
          }else{
            if(res.resultFlag != 0){
              console.log("打开读卡器失败");
              clearInterval(this.timerreadcard);
            }
          }
        })
      },
      readcard2(){
        if (this.loading){return}
        axios.get('http://127.0.0.1:19196/readcard').then(res=>{
          if(res.resultFlag == 0){
            this.zjlogin(res)
          }
        }).catch(res=>{
          if(res.resultFlag == 0){
            this.zjlogin(res)
          }else{
            if(res.errorMsg != '读卡失败'){
              console.log("未检测到证件读卡器");
              clearInterval(this.timerreadcard);
            }
          }
        })
      },
      zjlogin(res){
        this.loading = true;
        this.$api.login({Captcha:'sfzj_login',Password:res.certNumber}).then((res) => {
          clearInterval(this.timerreadcard);
          this.loading = false;
          this.$store.commit("setuserInfo", res.data);
          this.$router.push("index");
        }).catch((err) => {
          this.loading = false;
          this.$store.commit("setsnack", { message: "无效证件,登录失败！" });
          console.error(err);
        });
      },
      startvideo(){
        this.tracker.on('track', this.handleTracked, { camera: true });
      },
      endvideo(){
        this.tracker && this.tracker.removeListener('track', this.handleTracked) // && tracking.track('#facevideo', this.tracker, { camera: false });
      },
      handleTracked(event) {
        if(!event.data || event.data.length == 0){
          return
        }
        let _this = this
        event.data.forEach(function (rect) {
          _this.facetxt = '正在识别...'
          _this.photograph(rect)
        });
      },
      // 拍照
      photograph(rect) {
        let x=rect.x, y=rect.y, w=rect.width, h=rect.height, old=this.oldrect
        if (x == old.x && y == old.y && w == old.width && h == old.height){
          return
        }
        this.faceloginnum++
        if (this.faceloginnum > 100){
          this.dialog = false
          return
        }
        this.loginingnums++
        if(this.loginingnums > 2){
          return
        }
        this.oldrect = rect
        this.loading = true;
        if (this.faceWidth != this.videoWidth){
          let rate = this.videoWidth/this.faceWidth
          x = parseInt(x * rate)
          y = parseInt(y * rate)
          w = parseInt(w * rate)
          h = parseInt(h * rate)
        }
        
        let dw = w, dh = h, dsize = 100
        if(dw > dsize){
          dw = dsize
          dh = parseInt(dsize * rect.height/rect.width)
        }

        let canvas = this.$refs['canvas']
        canvas.width = dw
        canvas.height = dh

        let ctx = canvas.getContext('2d')
        ctx.drawImage(this.$refs['video'], x, y, w, h, 0, 0, dw, dh)
        let imgBase64 = canvas.toDataURL('image/jpeg', 0.7)   // 转base64格式、图片格式转换、图片质量压缩
        let str = imgBase64.replace('data:image/jpeg;base64,', '')
        // console.log("图片大小：",str.length);
        this.$api.facelogin({img:str}).then((res) => {
          if (this.dialog){
            this.loading = false;
            this.dialog = false;
            this.$store.commit("setuserInfo", res.data);
            this.$router.push("index");
          }
        }).catch((err) => {
          this.loading = false;
          this.loginingnums--
          // this.$store.commit("setsnack", { message: "err" });
          console.error(err);
        });
        
      },
      tologin(reGetCaptcha = false) {
        let data = {
          Username: this.username,
          Password: this.password,
        };
        if (this.CaptchaIds != "") {
          data.CaptchaIds = this.CaptchaIds;
          data.Captcha = this.Captcha;
        }
        if (reGetCaptcha) data = {};
        else if (!this.$refs.loginForm.validate()) return;
        this.Captcha = "";
        this.loading = true;
        this.$api.login(data).then((res) => {
          this.loading = false;
          if (res.data.CaptchaIds) {
            this.CaptchaB64s = res.data.CaptchaB64s;
            this.CaptchaIds = res.data.CaptchaIds;
            return;
          }
          this.$store.commit("setuserInfo", res.data);
          this.$router.push("index");
          // this.$router.go(-1);
        }).catch((err) => {
          this.loading = false;
          this.$store.commit("setsnack", { message: "登录失败！" });
          console.error(err);
        });
      },
    },
  };
</script>